import { FC, useState } from "react";
import { Link } from "react-router-dom";
import { TaskAreas } from "./TaskAreas";
import { CIODocuments } from "./CIODocuments";
import "../Contract.scss";

interface ICIOCollapsables {
  task_areas: boolean;
  documents: boolean;
}

export const CIO: FC = () => {
  const [isCollapsed, setIsCollapsed] = useState<ICIOCollapsables>({
    task_areas: true,
    documents: true,
  });
  return (
    <div className="Contract schedule70">
      <div className="Contract__wrapper">
        <Link className="back-to-contracts" to="/contract-vehicles">
          Back to Contracts
        </Link>
        <h1>CIO-SP3 Small Business</h1>
        <div className="Contract__wrapper__section">
          <h2>General Contract Information</h2>
          <div className="Contract__wrapper__section__content">
            <p>CIO-SP3 Small Business Contract Specifics:</p>
            <p>
              The Chief Information Officer-Solutions and Partners 3 (CIO-SP3)
              Small Business Government-Wide Acquisition Contract (GWAC) is a
              ten (10) year Indefinite Delivery/Indefinite Quantity (IDIQ)
              contract. This contract is intended to provide information
              technology (IT) solutions and services as defined in FAR 2.101(b)
              and further clarified in the Clinger-Cohen Act of 1996. These IT
              solutions and services include, but are not limited to, health and
              biomedical-related IT services to meet scientific, health,
              administrative, operational, managerial, and information
              management requirements.
            </p>
            <span>Contract Number: 75N98120D00057</span>
            <span>
              Sponsor Agency: National Institutes of Health NIH Info Tech
              Acquisition and Assessment Center Bethesda, MD 20892-7511
            </span>
            <span>Eligible Users: All Federal Agencies Worldwide</span>
            <span>
              Vehicle Type: Government-wide Acquisition Contracts (GWAC)
            </span>
            <span>Award Type: Multi-Award</span>
            <span>Contract POP: 11 May 2020 through 14 July 2022</span>
            <span>Program Ceiling: $20 Billion</span>
            <span>Prompt Payment Terms: Net 30</span>
            <span>
              Contract Manager: Phil Eagan, 757-431-2400 Ext 1643,
              phil.eagan@prosoft.us.com
            </span>
            <span>
              Program Manager: Karen A. Hinson, 757-431-2400 Ext 1637,
              karen.hinson@prosoft.us.com
            </span>
          </div>
          <TaskAreas
            isCollapsed={isCollapsed}
            setIsCollapsed={setIsCollapsed}
          />
          <CIODocuments
            isCollapsed={isCollapsed}
            setIsCollapsed={setIsCollapsed}
          />
        </div>
      </div>
    </div>
  );
};
